import ManageDevices from './ManageDevices';

export default ManageDevices;
